
import TNTBillingBase from "../../util/TNTBillingBase";

class BillingCategoryController extends TNTBillingBase {
    /*@ngInject*/
    constructor($state) {
        super();
        this.$state = $state;
        this.id = "billing_category";
        this.acl = {};
        this.hasACL = {};
    }
    
    $onInit() {
        super.$onInit()
        for (let key in this.acl['tnt_billing_' + this.id]) {
            this.hasACL[this.acl['tnt_billing_' + this.id][key]] = true;
        }
        
    }
}

export default BillingCategoryController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billing_category/billing_category.controller.js